import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { LoginFormComponent } from '../../components/forms/auth/login-form/login-form.component';
import { MbLogoComponent } from '../../components/common';
import { AuthActions } from '../../store/auth/auth.actions';
import { Store } from '@ngrx/store';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { selectAuthLoading } from '../../store/auth/auth.selectors';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-auth',
  standalone: true,
  imports: [
    CommonModule,
    NzInputModule,
    NzFormModule,
    NzIconModule,
    NzButtonModule,
    LoginFormComponent,
    MbLogoComponent,
    NzSpinModule,
  ],
  templateUrl: './auth.component.html',
})
export class AuthComponent {
  loading$: Observable<boolean>;
  currentYear = new Date().getFullYear();

  constructor(private store: Store) {
    this.loading$ = this.store.select(selectAuthLoading);
  }

  ngOnInit(): void {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    if (code) {
      this.store.dispatch(AuthActions.loginMinalocUsers({ code }));
    }
  }
}
